import { render } from "./VueGoogleAutocomplete.vue?vue&type=template&id=6501b61c"
import script from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"
export * from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__